import React from 'react';
import { Download } from 'lucide-react';

/**
 * 全站唯一的「Export Excel」按鈕（docs/dashboard-ui.md §3：綠色、圖示
 * w-4 h-4、text-sm）。儀表板、Quality Management、Management 的下載都用這一顆，
 * 要改長相只改這裡。檔案本身的樣式在 utils/excelExport.js，同樣一份。
 */
// 尺寸與字體同清單頁的「New …」主按鈕（px-3 py-2 text-sm font-medium）。
export const exportExcelBtnCls = 'inline-flex items-center justify-center gap-2 px-3 py-2 bg-green-600 text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap';

const ExportExcelButton = ({ onClick, disabled = false, busy = false, title, type = 'button' }) => (
  <button type={type} onClick={onClick} disabled={disabled || busy} title={title} className={exportExcelBtnCls}>
    <Download className="w-4 h-4" />
    {busy ? 'Exporting…' : 'Export Excel'}
  </button>
);

export default ExportExcelButton;
